import type { PublicAttachment } from '@cult/schemas';
import { Typography } from 'antd';
import { formatSize, iconFor, isPreviewableImage, isUploadUrl } from '../../utils';
import styles from './AttachmentsView.module.scss';

const { Text } = Typography;

type Props = {
  attachments: PublicAttachment[];
};

export const AttachmentsView = ({ attachments }: Props) => {
  if (attachments.length === 0) return null;

  // Images render inline only when CULT serves them; anything else falls back to a doc row.
  const images = attachments.filter(isPreviewableImage);
  const docs = attachments.filter((a) => !isPreviewableImage(a));

  return (
    <section className={styles.view} aria-label="Attachments">
      {images.length > 0 ? (
        <ul className={styles.grid}>
          {images.map((a) => (
            <li key={a.id}>
              <a href={a.url} target="_blank" rel="noopener noreferrer" aria-label={`Open ${a.filename}`}>
                <img src={a.url} alt={a.filename} loading="lazy" />
              </a>
            </li>
          ))}
        </ul>
      ) : null}
      {docs.length > 0 ? (
        <ul className={styles.docs}>
          {docs.map((a) => (
            <li key={a.id} className={styles.doc}>
              <span className={styles.docIcon}>{iconFor(a.mime)}</span>
              <span className={styles.docMeta}>
                {isUploadUrl(a.url) ? (
                  <a href={a.url} target="_blank" rel="noopener noreferrer">
                    {a.filename}
                  </a>
                ) : (
                  <Text title="External file links are not opened">{a.filename}</Text>
                )}
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {formatSize(a.size)}
                </Text>
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};
